import { useCallback, useEffect, useRef, useState } from "react"

export interface PlatformReplyNotice {
  type: "error" | "failed"
  message: string
}

interface PlatformReplyNoticeState {
  historyId: number
  notice: PlatformReplyNotice | null
}

export const useHistoryScopedPlatformReplyNotice = (historyId: number) => {
  const activeHistoryIdRef = useRef(historyId)
  const [state, setState] = useState<PlatformReplyNoticeState>({
    historyId,
    notice: null,
  })

  useEffect(() => {
    activeHistoryIdRef.current = historyId
    setState({ historyId, notice: null })
  }, [historyId])

  const setNotice = useCallback(
    (notice: PlatformReplyNotice | null) => {
      if (activeHistoryIdRef.current !== historyId) return
      setState({ historyId, notice })
    },
    [historyId]
  )

  return {
    notice: state.historyId === historyId ? state.notice : null,
    setNotice,
  }
}
